import {Injectable, NgZone} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, of, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

// HTTP Error handling
@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor
{
  constructor (private router: Router, private zone: NgZone) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    return next.handle(request).pipe(catchError(error => {
      let handled: boolean = false;

      if (error instanceof  HttpErrorResponse) {
        switch (error.status) {
          case 401:
            if (error.url && error.url.indexOf('api/v1/users/me') > -1) {
              console.log('Redirect to login: ', environment.loginUrl);
              this.zone.run(() => window.location.href = environment.loginUrl);
            } else {
              console.log('Redirect to unauthorized');
              this.router.navigateByUrl("/unauthorized");
            }
            handled = true;
            break;
          case 403:
            this.router.navigateByUrl("/unauthorized");
            console.log('Got Status Code 401. Redirect to unauthorized');
            handled = true;
            break;
        }
      }

      if (handled) {
        return of(error);
      } else {
        return throwError(error);
      }

    }));
  }

}
